import './styles/HomeProducts.css';
import {Link} from "react-router-dom";
import {IMAGE_URL} from "../../path";

type Props = {
    ranges: string;
    featured_products: {
        product_image: string;
        slug: string;
    }[];
}

function HomeProductsSection(props: Props) {

    return (
        <div className="home-products-container">
            <div className="products-inner">
                <div className="products-copy">
                    <h1>Products</h1>
                    <h2>Our Range</h2>
                    <p>{props.ranges}</p>
                </div>
                <div className="products-grid">
                    <div className="products-grid-items">
                        {props.featured_products.map((product, index) => (
                            <div className="products-grid-item" key={index}>
                                <div className="product-image">
                                    <img src={`${IMAGE_URL}${product.product_image}`} alt={product.slug}/>
                                </div>
                                <div className="products-grid-link">
                                    <Link to={`/product/${product.slug}`} className={"shop-products"}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path
                                                d="M10 4V16M4 10H16"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                            />
                                        </svg>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="products-grid-shelf">
                        <img alt="Shelf" src={"/wooden-platform@2x.png"} />
                    </div>
                    <div className="products-shop-all">
                        <Link to={"/products"} className={"shop-all-link"}>View all Products</Link>
                    </div>
                </div>
                <div className="product-grid-tablet">
                    {Array.from(
                        { length: Math.ceil(props.featured_products.length / 2) },
                        (_, rowIndex) => {
                            const products = props.featured_products.slice(
                                rowIndex * 2,
                                rowIndex * 2 + 2
                            );

                            return (
                                <div className="product-grid-tablet-row" key={rowIndex}>
                                    <div className="product-grid-tablet-items">
                                        {products.map((product, index) => (
                                            <div
                                                className="product-grid-tablet-item"
                                                key={index}
                                            >
                                                <div className="product-grid-tablet-image">
                                                    <img
                                                        src={`${IMAGE_URL}${product.product_image}`}
                                                        alt={product.slug}
                                                    />
                                                </div>

                                                <div className="product-grid-tablet-link">
                                                    <Link
                                                        to={`/product/${product.slug}`}
                                                        className="shop-products"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="20"
                                                            height="20"
                                                            viewBox="0 0 20 20"
                                                            fill="none"
                                                        >
                                                            <path
                                                                d="M10 4V16M4 10H16"
                                                                stroke="currentColor"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                            />
                                                        </svg>
                                                    </Link>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="product-grid-tablet-shelf">
                                        <img
                                            src="/wooden-platform-02.png"
                                            alt="Shelf"
                                        />
                                    </div>
                                </div>
                            );
                        }
                    )}

                    <div className="products-shop-all">
                        <Link to="/products" className="shop-all-link">
                            View all Products
                        </Link>
                    </div>
                </div>
                <div className="product-grid-mobile">
                    {props.featured_products.map((product, index) => (
                        <div className="product-grid-mobile-item" key={index}>
                            <div className="product-grid-mobile-image">
                                <img
                                    src={`${IMAGE_URL}${product.product_image}`}
                                    alt={product.slug}
                                />
                            </div>

                            <div className="product-grid-mobile-link">
                                <Link
                                    to={`/product/${product.slug}`}
                                    className="shop-products"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            d="M10 4V16M4 10H16"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </Link>
                            </div>

                            <div className="product-grid-mobile-shelf">
                                <img
                                    src="/wooden-platform-03.png"
                                    alt="Shelf"
                                />
                            </div>
                        </div>
                    ))}

                    <div className="products-shop-all">
                        <Link
                            to="/products"
                            className="shop-all-link"
                        >
                            View all Products
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeProductsSection;
